import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbInputDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { StringHelper } from 'src/app/directives/string-helper';
import { EditPersonModel } from 'src/app/models/api/actor-status-information.model';
import { UpdateExistingActorModel, UpdateExistingRequestActorModel } from 'src/app/models/api/update-existing-actor.model';
import { PersonApiClient } from 'src/app/services/api-clients/person.api-client';
import { LanguageEnum } from 'src/app/constants/language.enum';
import { EmailValidators } from 'src/app/validations/email.validators';
import { SetNormalizedEmail } from 'src/app/directives/set-normalized-email.function';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';

@Component({
    templateUrl: './request-status-person-dialog.modal.html',
    providers: [NgbInputDatepickerConfig],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RequestStatusPersonDialogModal {
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.Netherlands, CountryISO.UnitedKingdom];
  selectedCountryISOcode = CountryISO.Netherlands;
  private _personToEdit!: EditPersonModel;
  set personToEdit(val: EditPersonModel) {
    this._personToEdit = val;
    if (this._personToEdit) {
      // Clone personToEdit-object, so the object only changes when it is saved.
      this.person = { ...this._personToEdit };

      this.form.controls['firstname'].setValue(this.person.firstname);
      this.form.controls['prefix'].setValue(this.person.prefix);
      this.form.controls['lastname'].setValue(this.person.lastname);
      this.form.controls['email'].setValue(this.person.email);
      this.form.controls['mobile'].setValue(this.person.phone);
      this.form.controls['message'].setValue(this.person.personalMessage);
      this.form.controls['language'].setValue(this.person.language);
      // enable the only fields you are allowed to
      this.form.controls['email'].enable();
      this.form.controls['mobile'].enable();
      this.form.controls['email'].enable();
      this.getRequestForCurrentActor()

    }
  }

  get personToEdit(): EditPersonModel {
    return this._personToEdit;
  }
  requestGuid!: string;
  actorGuid!: string;
  @ViewChild('mobileElement') mobileElement: any;
  form: UntypedFormGroup;
  emailControl: FormControl;
  phoneControl: FormControl;
  languageControl: FormControl;
  selectedRequestIds: string[] = [];

  person!: EditPersonModel;
  translations: any = <any>{};

  stringHelper = new StringHelper();
  helpStatusEditPerson: string = 'Dialog.HelpStatusEditPerson';
  closeableWrapperTitle: string = 'Dialog.RequestsWillBeUpdated';
  requestsToUpdate: UpdateExistingRequestActorModel[] = [];

  constructor(private formBuilder: UntypedFormBuilder, public activeModal: NgbActiveModal,
    private translateService: TranslateService, private personApiClient: PersonApiClient) {
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
    this.emailControl = new UntypedFormControl({ value: '', disabled: true }, EmailValidators)
    this.phoneControl = new FormControl(undefined, [Validators.required]);
    this.languageControl = new FormControl(LanguageEnum.NL, []);
    this.form = this.formBuilder.group(
      {
        firstname: new UntypedFormControl({ value: '', disabled: true }),
        prefix: new UntypedFormControl({ value: '', disabled: true }),
        lastname: new UntypedFormControl({ value: '', disabled: true }),
        email: this.emailControl,
        mobile: this.phoneControl,
        language: this.languageControl,
        identificationMethod: new UntypedFormControl({ value: '', disabled: true }),
        message: new UntypedFormControl(({ value: '', disabled: true })),
        showPersonalNote: new UntypedFormControl({ value: false, disabled: true })
      });
  }

  getTranslations() {
    this.translateService.get([
      'Toasts.RequestsResendOne',
      'Toasts.RequestsResendOne'
    ]).subscribe(translation => {
      this.translations.toastsRequestsResendOne = translation['Toasts.RequestsResendOne'];
      this.translations.requestsWillBeUpdated = translation['Dialog.RequestsWillBeUpdated'];
    });
  }

  async getRequestForCurrentActor() {
    (await this.personApiClient.getRequestsForPerson(this.requestGuid, this.actorGuid)).subscribe({
      next: (data) => {
        this.requestsToUpdate = data;
        // add count of items that will be updated
        this.closeableWrapperTitle = this.translateService.instant('Dialog.RequestsWillBeUpdated', { count: this.requestsToUpdate.length });
      }
    });
  }

  personChange(key: string, event: any): boolean {
    const formField = document.getElementById(key);
    if (!formField) return true;

    if (this.form.controls[key].invalid) {
      formField.classList.add('is-invalid');
      if (key === 'mobile') (event.target as HTMLInputElement).classList.add('is-invalid');
      return false;
    }

    formField.classList.remove('is-invalid');
    if (key === 'mobile') (event.target as HTMLInputElement).classList.remove('is-invalid');
    return true;
  }

  markFormAsDirty() {
    this.form.markAsDirty();
  }

  back() {
    this.activeModal.close();
  }

  save() {
    let returnModel = new UpdateExistingActorModel();
    returnModel.mobile = this.form.controls['mobile'].value['e164Number'];
    returnModel.email = SetNormalizedEmail(this.form.controls['email'].value);
    returnModel.language = this.form.controls['language'].value;
    returnModel.personalMessage = this.form.controls['message'].value;
    returnModel.personGuids = this.requestsToUpdate.filter((s: UpdateExistingRequestActorModel) => s.checked).map(s => s.personGuid);
    this.activeModal.close(returnModel);
  }

  setSelectedRequest(event: any) {
    this.requestsToUpdate = event;
  }
}
